// @flow
export const AB_TYPES = {
    CONTROL: 'CONTROL',
    VARIANT: 'VARIANT',
    INELIGIBLE: 'INELIGIBLE',
};

export type experimentConfigProps = {
    testGroup: string,
    allocation: string,
};

/**
 * Return the A/B configuration
 */
export const getConfig = (serverVars: Object): { [string]: experimentConfigProps } => {
    return serverVars.get('abTestConfig') || {};
};
